import styled from 'styled-components';

import { styledInteraction, styledLayout, styledReset } from '@pkg/primitives';

import { tokens } from '../../tokens';

export const StyledEmojiAction = styled.button.attrs({ type: 'button' })`
    ${styledReset.button};
    ${styledInteraction.focusRing({ offset: -6, radius: 999 })};
    --yat_emoji-action-opacity: 0;
    display: grid;
    place-items: center;
    width: 100%;
    aspect-ratio: 1;

    &::after {
        ${styledInteraction.interactionDisable};
        ${styledLayout.positionCover({ offset: -6 })};
        z-index: 1;
        content: '';
        background-color: var(--yat_emoji-list-action-bg-color);
        border-radius: 999px;
        opacity: var(--yat_emoji-action-opacity);
        transition: opacity 200ms ease-in-out;
    }

    &:hover {
        --yat_emoji-action-opacity: 1;
    }

    &:active {
        --yat_emoji-action-opacity: 0.8;
    }
`;

export const Emoji = styled.span`
    ${styledReset.typography};
    position: relative;
    z-index: 2;
    display: block;
    font-size: ${tokens.emoji.size}px;
`;
